export enum AchievementTypeEnum {
  MANUAL = 'manual',
  PROGRESS = 'progress',
  QUANTITIVE = 'complete_number_of_content'
}
